/* eslint-disable no-dupe-keys */
export default {
  subscription_trigger_record: {
    name: '订阅触发记录',
    // 属性（一般与对象内容匹配）
    prop: {
      trigger_reason: '触发原因',
      notification_subscription: '通知订阅',
      triggerable: '触发对象',
      created_at: '触发时间',
      notification_records: '通知的管理员'
    },
    // Enum的属性
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询触发原因'
    }
    // 详情页标签
    // 标签标题
    // 标题
  }
}
